import { AxiosError } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";
import { TipoAnimal } from "../typings";

export function useListarTiposAnimal() {
  return useQuery<TipoAnimal[], AxiosError>("/v1/animal/tipos", async () => {
    const { data } = await http.get<TipoAnimal[]>("/v1/animal/tipos");

    return data;
  });
}
